import { render, staticRenderFns } from "./BookP.vue?vue&type=template&id=e067edb8&scoped=true&"
import script from "./BookP.vue?vue&type=script&lang=js&"
export * from "./BookP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e067edb8",
  null
  
)

export default component.exports